module.exports = require("./yi.js");